module.exports = __webpack_public_path__ + "img/img-profile-blue.06b7e8ba.svg";